import axios from 'axios';

export const FETCH_CART = 'FETCH_CART';
export const CHECK_FORM_ERRORS = 'CHECK_FORM_ERRORS';
export const LOADING = 'LOADING';
export const PRODUCT_QUANTITY = 'PRODUCT_QUANTITY';
let fetchCartCancelToken = null;
let updateCartCancelToken = null;

export function fetchCart( updatedProducts = null ) {
	return ( dispatch ) => {
		dispatch( setLoading( true ) );
		'use strict';
		const url = `${ wpApiSettings.root }isda/v1/cart/prices`;

		// Cancel previous request if it exists
		if ( fetchCartCancelToken ) {
			fetchCartCancelToken.cancel( 'Operation canceled due to new request.' );
		}

		// Create a new CancelToken
		fetchCartCancelToken = axios.CancelToken.source();

		axios.get( url, {
			...get_config(), cancelToken: fetchCartCancelToken.token
		} ).then( response => {
			const fetchedCart = response.data;

			if ( updatedProducts ) {
				if ( !fetchedCart.products ) {
					fetchedCart.products = [];
				}
				const fetchedProducts = fetchedCart.products.reduce( ( acc, product ) => {
					acc[ product.iMIS_code ] = product.quantity;
					return acc;
				}, {} );

				const mismatch = Object.keys( updatedProducts )
				                       .some( iMISCode => updatedProducts[ iMISCode ] !== fetchedProducts[ iMISCode ] );

				if ( mismatch ) {
					// If there's a mismatch, fetch the cart again
					dispatch( fetchCart() );
					return;
				}
			}

			dispatch( {
				          type: FETCH_CART, payload: fetchedCart
			          } );
		} ).catch( error => {
			if ( !axios.isCancel( error ) ) {
				console.error( 'Error fetching cart:', error );
				// Additional logging for debugging
				console.error( 'Error details:', error.response
				                                 ? error.response.data
				                                 : 'No response data' );
			}
		} ).finally( () => {
			dispatch( setLoading( false ) );
		} );
	};
}

export function updateCart( products ) {
	return ( dispatch ) => {
		dispatch( setLoading( true ) );
		const url = `${ wpApiSettings.root }isda/v1/cart`;
		const data = {
			items: products, nonce: wpApiSettings.nonce
		};

		// Cancel previous update request if it exists
		if ( updateCartCancelToken ) {
			updateCartCancelToken.cancel( 'Operation canceled due to new request.' );
		}

		// Create a new CancelToken for update
		updateCartCancelToken = axios.CancelToken.source();

		axios.post( url, data, {
			...get_config(), cancelToken: updateCartCancelToken.token
		} ).then( response => {
			// Cancel any ongoing fetchCart request before dispatching a new one
			if ( fetchCartCancelToken ) {
				fetchCartCancelToken.cancel( 'Operation canceled due to new request.' );
			}
			dispatch( fetchCart( products ) );
		} ).catch( error => {
			if ( !axios.isCancel( error ) ) {
				console.error( 'Error updating cart:', error );
				dispatch( setLoading( false ) );
			}
		} );
	};
}

export function clearCart() {
	return ( dispatch ) => {
		const url = `${ wpApiSettings.root }isda/v1/cart`;
		axios.delete( url, get_config() ).then( response => {
			dispatch( fetchCart() );
		} );
	};
}

export function updateFormErrors( fields ) {
	return ( dispatch ) => {
		dispatch( {
			          type: CHECK_FORM_ERRORS, payload: fields
		          } );
	};
}

export function setLoading( loading ) {
	return ( dispatch ) => {
		dispatch( {
			          type: LOADING, payload: loading
		          } );
	};
}

function get_config() {
	let config = {
		headers: {
			'X-WP-Nonce': wpApiSettings.nonce
		}
	};
	return config;
}